import React, { useState } from 'react';
import { Box, Button, Paper, Typography, TextField, Alert } from '@mui/material';
import { supabase } from '../../lib/supabaseClient';
import './Login.css';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Query the analytics_admin table
      const { data, error } = await supabase
        .from('analytics_admin')
        .select('*')
        .eq('email', email.toLowerCase())
        .eq('password', password)
        .single();

      if (error) {
        console.error('Supabase error:', error);
        throw error;
      }

      if (data) {
        console.log('Login successful:', data);
        // Pass only necessary user data
        onLogin({
          email: data.email,
          id: data.id
        });
      } else {
        setError('Invalid email or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Paper elevation={3} className="login-paper">
        <Box p={3}>
          <Typography variant="h4" gutterBottom align="center">
            <b>My CallSheet App</b>
          </Typography>
          <Typography variant="subtitle1" gutterBottom align="center">
            Admin Dashboard
          </Typography>
          
          <form onSubmit={handleLogin}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            
            <TextField
             label="Email"
             type="email"
             fullWidth
             margin="normal"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             required
             autoComplete="email"
             autoFocus
             sx={{
                 "& .MuiInputBase-root": { transition: "0.3s" },
                 "& .MuiInputBase-root:focus-within": { borderColor: "#fc4e00" },
                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                 borderColor: "#fc4e00",
                 },
                 "& .MuiInputLabel-root.Mui-focused": {
                 color: "#fc4e00",
                 },
             }}
            />

            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              sx={{
                "& .MuiInputBase-root": { transition: "0.3s" },
                "& .MuiInputBase-root:focus-within": { borderColor: "#fc4e00" },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#fc4e00",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                color: "#fc4e00",
                },
            }}
            />
            
            <Button 
              variant="contained" 
              fullWidth 
              type="submit"
              size="large"
              sx={{ mt: 3, backgroundColor: "#fc4e00", "&:hover": { backgroundColor: "#d94300" } }}
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </Box>
      </Paper>
    </div>
  );
};

export default Login;